<template>
  <div class="profile content">

    <h1>Аккаунт</h1>

    <template
      v-if="user.is_client"
    >
      <div class="profile__item">
        <p class="subtitle">Личные данные</p>

        <Row type="flex" :gutter="30">
          <Col>
            <v-field
              v-model.trim="profile.fio"
              label="ФИО"
            />
          </Col>
          <Col>
            <v-field
              v-model.trim="profile.phone"
              label="Номер телефона"
            />
          </Col>
          <Col>
            <v-field
              v-model.trim="profile.email"
              label="Эл. почта"
            />
          </Col>
        </Row>

        <v-button
          text="Обновить данные"
          color="blue"
          :disabled="!submitProfileIsValid"
          @click="editProfile"
        />

        <div
          v-if="message.prop === 'profile'"
        >
          <span class="message" :class="`message--${message.type}`">{{
            message.text
          }}</span>
        </div>
      </div>

      <div class="profile__item">
        <p class="subtitle">Обновить пароль</p>
        <Row type="flex" :gutter="30">
          <Col>
            <v-field
              v-model.trim="password.current_password"
              type="password"
              label="Текущий пароль"
              :is-error="!!errorHandler.getErrorByName('current_password')"
              :error-text="errorHandler.getErrorByName('current_password')"
            />
          </Col>
          <Col>
            <v-field
              v-model.trim="password.new_password"
              type="password"
              label="Новый пароль"
              :is-error="!!errorHandler.getErrorByName('new_password')"
              :error-text="errorHandler.getErrorByName('new_password')"
            />
          </Col>
          <Col>
            <v-field
              v-model.trim="password.repeatPassword"
              type="password"
              label="Подтвердить пароль"
              :is-error="!!password.repeatPassword && !repeatPasswordIsValid"
            />
          </Col>
        </Row>

        <v-button
          text="Обновить пароль"
          color="blue"
          :disabled="!submitPasswordIsValid()"
          @click="changePassword"
        />

        <div
          v-if="message.prop === 'password'"
        >
          <span class="message" :class="`message--${message.type}`">{{
            message.text
          }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="profile__item">
        <v-checkbox
          :value="user.chat_enabled"
          label-tag="label"
          @input="setChatAvailability"
        >
          Чат в заявках
        </v-checkbox>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VField from "@/components/VField";
import VCheckbox from "@/components/VCheckbox";
import VButton from "@/components/VButton";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import showMessageMixin from "@/mixins/showMessageMixin";


export default {
  name: "Profile",

  components: {
    VField,
    VButton,
    VCheckbox
  },

  mixins: [showMessageMixin],

  data() {
    return {
      profile: "",
      password: {
        current_password: "",
        new_password: "",
        repeatPassword: ""
      },
      errorHandler: new ErrorHandlerService("", "password")
    };
  },

  computed: {
    ...mapGetters({
      user: "user/getUser",
      userType: "getUserType"
    }),

    repeatPasswordIsValid() {
      return this.password.new_password === this.password.repeatPassword;
    },

    submitProfileIsValid() {
      return !!this.profile.fio && !!this.profile.phone && !!this.profile.email;
    }
  },

  watch: {
    "password.new_password"(val) {
      this.errorHandler.checkErrorIsFixed("new_password", !!val);
    }
  },

  mounted() {
    this.profile = { ...this.user };
  },

  methods: {
    async changePassword() {
      try {
        await this.user.changePassword(
          this.password.current_password,
          this.password.new_password
        );
        this.showMessage("Пароль успешно обновлен", "password");
      } catch (err) {
        this.errorHandler = new ErrorHandlerService(
          err.response.data,
          "password"
        );
      }
    },

    async setChatAvailability() {
      await this.user.setChatAvailability(!this.user.chat_enabled);
    },

    async editProfile() {
      try {
        await this.user.editProfile({
          fio: this.profile.fio,
          phone: this.profile.phone,
          email: this.profile.email
        });
        this.showMessage("Личные данные успешно обновлены", "profile");
      } catch (err) {
        console.warn(err.response.data);
      }
    },

    checkErrorIsFixed(name) {
      return this.errorHandler.checkErrorIsFixed(name, !!this.password[name]);
    },

    submitPasswordIsValid() {
      return (
        !!this.password.current_password &&
        !!this.password.new_password &&
        this.repeatPasswordIsValid === true
      );
    }
  }
};
</script>

<style lang="scss">
.profile {
  box-sizing: border-box;
  min-height: 940px;
  padding: 60px 40px;
  .input {
    width: 310px;
  }
  .subtitle {
    font-weight: 600;
    margin-bottom: 40px;
  }
  &__item {
    margin-bottom: 50px;
    .button {
      margin-top: 20px;
    }
  }
}
</style>
